import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";

export default function DispatcherSearchBar({ value, onChange, rightSlot }) {
  return (
    <div className="bg-white p-16 d-flex align-items-center gap-3">
      <Searchbar
        style="search search-dark input-group"
        placeholder={trans("Search by request number, address, complaint, customer name or mobile number")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {rightSlot && <div className="ms-auto d-flex align-items-center gap-3">{rightSlot}</div>}
    </div>
  );
}
